export default __webpack_public_path__ + "static/NotoSans-Regular.subset-813887df5d423aca0e674283305e891f.woff2";